// Imports
import { useEffect, useState } from 'react';
import LoadingRow from '../../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetBoardMembersResponse } from '../../../../../../shareables/types/api/main/website/page/type/203/board-members/get';
import Table from '../shared-components/table';
import EmptyStateRow from '../shared-components/table/empty-state-row';
import BoardMembersRow from './row';


// Define the accepted props
interface Props {
	pageID: number;
	storybookBoardMembers?: GetBoardMembersResponse;
}


// Function component
const BoardMembers: React.FC<Props> = ({ pageID, storybookBoardMembers }) => {
	// Use state
	const [boardMembers, setBoardMembers] = useState<GetBoardMembersResponse | null>(storybookBoardMembers ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load board members on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetBoardMembersResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/203/board-members`,
				completion: (json) => {
					setBoardMembers(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// Return JSX
	return (
		<div>
			<Table>
				<thead>
					<tr>
						<th>Board member</th>
						<th>Term ends</th>
						<th>Contact info</th>
					</tr>
				</thead>
				
				<tbody>
					{boardMembers?.map((boardMember) => (
						<BoardMembersRow key={boardMember.id} boardMember={boardMember}></BoardMembersRow>
					))}
					
					{boardMembers?.length === 0 && <EmptyStateRow>No board members yet…</EmptyStateRow>}
					
					{!boardMembers && <LoadingRow />}
				</tbody>
			</Table>
		</div>
	);
};

export default BoardMembers;
